const PRELOAD_RADIUS = 1;

type ShouldLoadGalleryPaginatorSlideParams = {
    slideIndex: number;
    currentSlideIndex: number;
    hasInteracted: boolean;
};

/**
 * До первого листания грузим изображения только текущего слайда и соседей.
 * После взаимодействия разрешаем загрузку всех изображений.
 *
 * @param params.slideIndex индекс слайда
 * @param params.currentSlideIndex индекс текущего слайда галереи
 * @param params.hasInteracted было ли листание галереи
 * @returns нужно ли подставлять src изображений
 * @kind helper
 */
export function shouldLoadGalleryPaginatorSlide({
    slideIndex,
    currentSlideIndex,
    hasInteracted,
}: ShouldLoadGalleryPaginatorSlideParams): boolean {
    return hasInteracted || Math.abs(slideIndex - currentSlideIndex) <= PRELOAD_RADIUS;
}
